import { Form, FormProps, message } from "antd";
import api from "common/api";
import { IUsers } from "common/types/users";
import { FieldData } from "rc-field-form/es/interface";
import React, { FC, createContext, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Context = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const onFinish: FormProps["onFinish"] = async (values) => {
    try {
      const payload = {
        ...values,
      };
      const response = await api.users.addUser(payload, id);
      message.success("Foydalanuvchi yaratildi");
      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };

  const getById = async (id: string) => {
    try {
      const response = await api.users.getById(id);
      const fields: FieldData[] = (
        Object.keys(response.data) as (keyof IUsers)[]
      ).map((key) => ({
        name: key,
        value: response.data[key],
      }));
      form.setFields(fields);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    if (id)
      try {
        const response = await api.users.delete(id);
        message.success("Foydalanuvchi o'chirildi");
        navigate(-1);
      } catch (err) {
        console.log(err);
      }
    else navigate(-1);
  };

  useEffect(() => {
    if (id) getById(id);
  }, []);

  return {
    state: { form },
    actions: { onFinish, handleDelete },
  };
};

const UsersAddContext = createContext<any>({ state: {}, actions: {} });

export const UsersAddContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <UsersAddContext.Provider value={value}>
      {children}
    </UsersAddContext.Provider>
  );
};

export default function useUsersAddContext() {
  return useContext<ReturnType<typeof Context>>(UsersAddContext);
}
